import { gql, mutate, watchQuery } from '@/services/apollo'


const GET_JURISDICTIONS = gql`
  query jurisdictionPage($input: JurisdictionPageInput!) {
    jurisdictionPage {
      jurisdictions(input: $input) {
        id,
        key,
        description
      }
      totalCount
    }
  }
`


export default {
  getJurisdictionPage (variables) {
    return watchQuery({
      query: GET_JURISDICTIONS,
      variables
    })
  },
  getJurisdictions () {
    return watchQuery({
      query: GET_JURISDICTIONS, variables: { input: { limit: 0, offset: 0 } } })
  },
  createJurisdiction (input) {
    return mutate({
      mutation: gql`
        mutation createJurisdiction($input: CreateJurisdictionInput!) {
          createJurisdiction(input: $input) {
            id,
            key,
            description
          }
        }
      `,
      variables: { input }
    })
  },
  getJurisdiction (variables) {
    return watchQuery({
      query: gql`
        query jurisdiction($input: JurisdictionInput!) {
          jurisdiction(input: $input) {
            id,
            key,
            description
          }
        }
      `,
      variables
    })
  },
  editJurisdiction (input) {
    return mutate({
      mutation: gql`
        mutation editJurisdiction($input: EditJurisdictionInput!) {
          editJurisdiction(input: $input) {
            id,
            key,
            description
          }
        }
      `,
      variables: { input }
    })
  },
  deleteJurisdiction (input) {
    return mutate({
      mutation: gql`
        mutation deleteJurisdiction($input: DeleteJurisdictionInput!) {
          deleteJurisdiction(input: $input)
        }
      `,
      variables: { input }
    })
  }
}
